import { ApiError } from "@kkp/api-client";

export function apiErrorMessage(err: unknown, fallback: string): string {
  if (err instanceof ApiError && err.errorDetails?.length) {
    return err.errorDetails.map((d) => d.message).join("; ");
  }
  return err instanceof Error && err.message ? err.message : fallback;
}
